import React, { useState } from 'react';
import _ from 'lodash';
import { Box, Input } from '@kufox/mui';
import { SearchOutlined } from '@kufox/icons';
import { styled, isPropValid } from '@kufox/mui/emotion';
import { useLang } from '../../hookTool';
import { isForbiddenCountry } from '../../common/tools';

const Overlay = styled('div', {
  shouldForwardProp: (props) => isPropValid(props),
})(({ theme }) => {
  return {
    width: '240px',
    height: '360px',
    boxShadow: theme.shadows.base,
    borderRadius: '4px',
    background: theme.colors.base,
    position: 'absolute',
    left: -56,
    top: 22,
    '& .activeItem': {
      width: '100%',
      height: '48px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '48px',
      color: theme.colors.primary,
      position: 'relative',
    },
    '& .overlayHeader': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px 8px 0 8px',
    },
    '& .overlayBody': {
      height: '300px',
      overflow: 'auto',
      margin: '8px 0',
      '&::-webkit-scrollbar': {
        background: 'transparent',
        width: '4px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '2px',
        background: theme.colors.text60,
      },
    },
    '& .overlayItem': {
      width: '100%',
      height: '48px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer',
      '&:hover': {
        background: theme.colors.cover8,
        color: theme.colors.primary,
      },
    },
  };
});

const Empty = styled('div', {
  shouldForwardProp: (props) => isPropValid(props),
})(() => {
  return {
    width: '24px',
    height: '16px',
    background: 'transparent',
    marginRight: '8px',
  };
});

function OverLay({ data, isCn, onClickCode, checkForbidden, dropForbidden }) {
  const [searchValue, setSearchValue] = useState('');

  const { t } = useLang();

  const countries = data.filter((country) => {
    // dropForbidden = true 不显示该国家
    if (dropForbidden === true && isForbiddenCountry(country.mobileCode)) {
      return false;
    }
    const code = `+${country.mobileCode}`;
    let isCountry;
    if (isCn) {
      isCountry = country.cn.includes(searchValue);
    } else {
      isCountry = country.en.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase());
    }
    const forbiddenItem = isForbiddenCountry(country.mobileCode);
    const isForbidden = checkForbidden && forbiddenItem;
    let otherSearchTxt = '';
    if (isCn && isForbidden) {
      otherSearchTxt = forbiddenItem.aliasName.includes(searchValue);
    } else if (!isCn && isForbidden) {
      otherSearchTxt = forbiddenItem.aliasNameEN
        .toLocaleLowerCase()
        .includes(searchValue.toLocaleLowerCase());
    }
    if (otherSearchTxt) return true;
    if (searchValue && isForbidden) {
      return false;
    }
    return code.includes(searchValue) || isCountry;
  });

  const handleSearch = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setSearchValue(value);
  };

  const getCountryName = (country, isForbidden, forbiddenItem) => {
    if (!isForbidden) {
      return isCn ? country.cn : country.en;
    }
    return isCn ? forbiddenItem.aliasName : forbiddenItem.aliasNameEN;
  };

  return (
    <Overlay>
      <div className="overlayHeader">
        <Input
          placeholder={t('search')}
          fullWidth
          onChange={handleSearch}
          value={searchValue}
          prefix={<SearchOutlined size={24} />}
        />
      </div>
      <div className="overlayBody">
        {_.map(countries, (country, key) => {
          const forbiddenItem = isForbiddenCountry(country.mobileCode);
          const isForbidden = checkForbidden && forbiddenItem;
          return (
            <div className="overlayItem" key={key} onClick={() => onClickCode(country.mobileCode)}>
              <Box display="flex" alignItems="center">
                {!isForbidden ? (
                  <img
                    style={{ marginRight: '8px' }}
                    width={24}
                    alt={country.code}
                    src={country.ico}
                  />
                ) : (
                  <Empty />
                )}
                {getCountryName(country, isForbidden, forbiddenItem)}
              </Box>
              <Box>{isForbidden ? '' : `+${country.mobileCode}`}</Box>
            </div>
          );
        })}
      </div>
    </Overlay>
  );
}

export default OverLay;
